import axios from 'axios';
import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { showErrorNotification, showInfoNotification, showSuccessNotification } from '../../Services/Notifications';
import { Constants } from '../../Utils/Constants';
import { getUserData, setNumeric } from '../../Utils/utils';
import './Login.scss';
let error = '';
// let show =  false;
//const [errorMessage, setErrorMessage] = useState('');

const Login = (props) => {
  const navigate = useNavigate();
  const cookies = new Cookies();

  let [show, setShow] = useState(false);
  let [showResend, setShowResend] = useState(false);
  let [employeeCode, setEmployeeCode] = useState('');
  let [otp, setOtp] = useState('');
  let [timer, setTimer] = useState('10:00s');
  const ref = useRef(null);

  const sendOtp = (e) => {
    e.preventDefault();
    setShowResend(false);
    if (!employeeCode) {
      error = `Agent Code cannot be empty.`;
      //   showErrorNotification(error);
      return false;
    }
    ref.current.disabled = true;
    try {
      const callSendOtp = async () => {
        try {
          let response = await axios.post(Constants.BACKEND_API_URL + 'services/login/request', {
            code: employeeCode,
          });
          ref.current.disabled = false;
          console.log(response);
          response = response.data;
          if (response.responseCode !== 200) throw new Error(response.responseMessage);
          setShow(true);
          showInfoNotification('Otp has been sent successfully.');
          let timer = '10';
          let interval = setInterval(function () {
            //by parsing integer, I avoid all extra string processing
            let seconds = parseInt(timer);
            --seconds;
            if (seconds < 0) {
              clearInterval(interval);
            }
            if (seconds !== -1) {
              setTimer(`00:0${seconds}s`);
            } else {
              setShowResend(true);
              setTimer('10:00s');
            }
            timer = seconds;
          }, 1000);
        } catch (e) {
          showErrorNotification(e.message);
          return e.message;
        }
      };
      callSendOtp();
    } catch (e) {
      ref.current.disabled = false;
      console.log(e);
    }
  };

  const setCookie = (value, keyName) => {
    // console.log("values", value, keyName);
    cookies.set(keyName, value, { path: '/' });
    // console.log(keyName, cookies.get(keyName));
  };
  // const setLocalStorage = (keyname, value) => {
  //     localStorage.setItem(keyname, value);
  //     // console.log(keyname, localStorage.getItem(keyname));
  // };

  const getStarted = (e) => {
    e.preventDefault();
    if (!employeeCode || !otp) {
      error = `Agent Code & OTP cannot be empty.`;
      //   showErrorNotification(error);
      return false;
    }
    ref.current.disabled = true;
    try {
      const callGetStarted = async () => {
        try {
          let response = await axios.post(Constants.BACKEND_API_URL + 'services/login/verify', {
            code: employeeCode,
            otp,
          });
          ref.current.disabled = false;
          console.log(response);
          response = response.data;
          if (response.responseCode !== 200) throw new Error(response.responseMessage);
          setShow(true);
          showSuccessNotification('Verified!!');
          setCookie(response.responseData.auth, 'access_token');
          
          getUserData(props.setUser, navigate);
          navigate('/');
        } catch (e) {
          showErrorNotification(e.message);
          return e.message;
        }
      };
      callGetStarted();
    } catch (e) {
      ref.current.disabled = false;
      console.log(e);
    }
  };
  return (
    <div className="container-fluid">
      <div className="row login-page">
        <div className="col-md-6 leftimage">
          {/* <a href={commonConstant.REMITX_URL}><img alt="" className="logologin" src="https://www.remitx.com/remitx-images/logologin.png" /></a> */}
          <img alt="" className="img-fluid" src="https://remitxb2c.s3.ap-south-1.amazonaws.com/1682406891882-bg-login.png" />
        </div>
        <div className="col-md-6">
          <div className="boxlogin">
            <Link className="mobilelogin" to="index">
              {
                //       commonConstant.AGENT_CODES_FOR_LOGOS.includes(employeeCode) ? (
                //         <img
                //           src={`/${employeeCode}.png`}
                //           alt="Logo"
                //           title=""
                //           style={{ width : 'auto'}}
                //         />
                //   ) : <img src="https://www.remitx.com/remitx-images/remitx.svg" alt="Logo" title="" />
              }
            </Link>
            <h1 className="login_heading" style={{ textAlign: 'center!important' }}>
              Login to Portal
            </h1>
            <div>
              <div className="login">
                <form onSubmit={!show ? sendOtp : getStarted}>
                  <div className="posre email_box">
                    <label htmlFor="AgentID" className="form-label">
                      Employee Code
                    </label>
                    <span className=" icon email"></span>
                    <input
                      type="text"
                      value={employeeCode}
                      className="form-control"
                      onChange={(event) => {
                        setEmployeeCode(event.target.value);
                      }}
                      onKeyDown={setNumeric}
                      placeholder="Please Enter the Employee Code"
                    />
                  </div>
                  {show && (
                    <div className="posre mrg-t15">
                      <label htmlFor="OTP" className="form-label">
                        OTP
                      </label>
                      <span className=" icon password"></span>
                      <input
                        value={otp}
                        type="text"
                        className="otp form-control"
                        id="OTP"
                        onChange={(event) => {
                          setOtp(event.target.value);
                        }}
                        placeholder="Enter OTP"
                      />
                      {!showResend && (
                        <p
                          style={{
                            float: 'right',
                            marginBottom: '0px',
                          }}
                        >
                          {timer}
                        </p>
                      )}
                      {showResend && (
                        <div className="resend_otp float-end">
                          <span
                            style={{
                              color: 'green',
                              fontSize: '12px',
                            }}
                            className="hide"
                            id="successOtp"
                          >
                            OTP sent successfully{' '}
                          </span>
                          <Link
                            to="#!"
                            onClick={sendOtp}
                            style={{
                              color: 'blue',
                              textDecoration: 'none',
                            }}
                          >
                            Resend OTP
                          </Link>
                        </div>
                      )}
                    </div>
                  )}
                  <button ref={ref} type="submit" className="mt-3 btn btn-primary send_otp">
                    {!show ? 'Send OTP' : 'Get Started'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
